'use client';

import { useCallback, useState } from 'react';

const useHeaderMobileMenu = () => {
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  const closeMobileMenu = useCallback(() => {
    setIsMobileOpen(false);
  }, []);

  const openMobileMenu = useCallback(() => {
    setIsMobileOpen(true);
  }, []);

  return {
    closeMobileMenu,
    isMobileOpen,
    openMobileMenu,
  };
};

export default useHeaderMobileMenu;
